import React, { Component } from "react";

export class StepColorTertiary extends Component {
  render() {
    const { colors, state, setTertiaryColor } = this.props;

    let indexChecked = 0;
    let tertiaryIndexChecked = 0;
    const tertiaryColorSelected =
      state && state.tertiaryColorSelected.split(",");

    if (tertiaryColorSelected) {
      indexChecked = parseInt(tertiaryColorSelected[0]);
      tertiaryIndexChecked = parseInt(tertiaryColorSelected[1]);
    }

    return (
      <div data-test="StepColorTertiaryComponent">
        <h6 className="text-uppercase font-weight-700 font-size-14px mb-4">Elige el tono</h6>
        {colors &&
          colors.length > 0 &&
          colors.map((color, index) => {
            return (
              <div
                className="row align-items-center mb-3 "
                key={color.wizard_color_tertiary_row_name + index}
              >
                <div className="col-4">
                  <p className="font-size-12px mb-0">{color.wizard_color_tertiary_row_name}</p>
                </div>
                <div className="col-8">
                  <div className="d-flex justify-content-between">
                    {color.wizard_colors_tertiary_repeater &&
                      color.wizard_colors_tertiary_repeater.map(
                        (tertiaryColors, tertiaryIndex) => {
                          const combineIndexTertiary = `${index},${tertiaryIndex}`;

                          return (
                            <div
                              className={`roundPicker ${
                                state.tertiaryColorSelected ===
                                combineIndexTertiary
                                  ? "active"
                                  : ""
                              }`}
                              key={
                                tertiaryColors.wizard_color_tertiary_picker +
                                tertiaryIndex
                              }
                              style={{
                                backgroundColor:
                                  tertiaryColors.wizard_color_tertiary_picker
                              }}
                            >
                              <input
                                type="radio"
                                id={`${index},${tertiaryIndex}`}
                                name="roundPicker"
                                value={`${index},${tertiaryIndex}`}
                                defaultChecked={
                                  index === indexChecked &&
                                  tertiaryIndex === tertiaryIndexChecked
                                }
                                onChange={ev => setTertiaryColor(ev)}
                                style={{
                                  backgroundColor:
                                    tertiaryColors.wizard_color_tertiary_picker
                                }}
                              />
                              <label
                                htmlFor={`${index},${tertiaryIndex}`}
                              ></label>
                            </div>
                          );
                        }
                      )}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    );
  }
}

export default StepColorTertiary;
